<template>
  <div class="app-sidebar app-sidebar--dark" :class="{ 'sidebar-disable': initPage }" style="z-index: 1010 !important;">
    <div class="sidebar-navigation">
      <sidebar-menu :disableHover="initPage" :menu="dataMenu">
        <div slot="header">
          <div class="nav-logo w-100 text-center my-4">
            <router-link tag="a" class="d-block w-auto" active-class="active" to="/" exact>
              <b-img center fluid-grow :src="require('@/assets/izidok.png')" alt="izidok" class="py-0 px-4" />
            </router-link>
          </div>
        </div>
        <div slot="dropdown-icon" style="font-size:1.4em;">&gt;</div>
      </sidebar-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SidebarMenu } from "vue-sidebar-menu";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faUser,
  faUsers,
  faFileAlt,
  faFileMedical,
  faCog,
  faArchive,
  faThLarge,
  faPuzzlePiece,
  faClone,
  faMoneyBill,
  faBriefcaseMedical,
  faStethoscope,
  faBriefcase,
  faHospital,
  faAddressBook,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faHome,
  faUser,
  faUsers,
  faFileAlt,
  faFileMedical,
  faCog,
  faArchive,
  faClone,
  faThLarge,
  faPuzzlePiece,
  faMoneyBill,
  faBriefcaseMedical,
  faStethoscope,
  faBriefcase,
  faHospital,
  faAddressBook,
  faUserCog
);

export default {
  components: {
    SidebarMenu
  },
  props: {
    sidebarbg: String
  },
  data() {
    return {
      collapsed: false
    };
  },
  computed: {
    ...mapGetters({
      initPage: "sidebar/initPage",
      getRolesName: "getRolesName",
      klinikUser: "klinikUser",
      faskes: "faskes",
      isDpm: "getFaskesType",
      isIntegratedSatusehat: "satusehatAuthValid" 
    }),
    sidebarCollapsed: {
      get() {
        return this.$store.state.sidebar.sidebarCollapsed;
      },
      set(value) {
        this.$store.commit("sidebar/SET_SIDEBAR_COLLAPSED", value);
      }
    },
    dataMenu() {
      const menus = this.haveMenuAccess();
      return menus;
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
  }
};
</script>

<style lang="scss">
.app-sidebar {
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 999 !important;

  .vsm-arrow:after {
    content: "" !important;
  }
}
</style>
